import { Button, Popover } from "antd";
import { FallOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useState } from "react";

interface button {
  onClick: any;
}

const TransactionButton = ({ onClick }: button) => {
  const [t] = useTranslation("common");
  const [isTransaction, setIsTransactions] = useState(false);
  const content = <div>{t("transactions")}</div>;
  const handleTransactionClick = () => {
    if (!isTransaction) {
      onClick();
      setIsTransactions(true);
    }
  };
  return (
    <>
      <Popover content={content} mouseEnterDelay={0} mouseLeaveDelay={0}>
        <Button
          className="Button"
          type="text"
          icon={<FallOutlined style={{ color: "#212121", fontSize: "14px" }} />}
          onClick={handleTransactionClick}
          disabled={isTransaction}
          size={"small"}
        />
      </Popover>
    </>
  );
};

export default TransactionButton;
